import React from 'react';
import { ExternalLink, Img, InternalLink } from '~frontend-common/components/ui';
import { Box } from '~ui-kit/components/box/box';
import { styled } from '~ui-kit/styled-components';

interface NavbarLogoProps {
  linkTo: string;
  imageSrcCompact: string;
  imageSrcFull: string;
  compact?: boolean;
  external?: boolean;
  openNewTab?: boolean;
}

// If mobile, only display logo check mark instead of full logo
export function NavbarLogo({
  linkTo: to,
  openNewTab = false,
  external = openNewTab,
  compact = false,
  imageSrcCompact,
  imageSrcFull,
}: NavbarLogoProps) {
  const logoElement = <Logo src={compact ? imageSrcCompact : imageSrcFull} />;

  return (
    <LogoContainer $smaller={compact}>
      {external ? (
        <ExternalLink href={to} openNewTab={openNewTab}>
          {logoElement}
        </ExternalLink>
      ) : (
        <InternalLink to={to}>{logoElement}</InternalLink>
      )}
    </LogoContainer>
  );
}

export const Logo = styled(Img)`
  height: 100%;
  display: block;
`;

export const LogoContainer = styled(Box).attrs({ justifyContent: 'center', alignItems: 'center' })<{
  $smaller: boolean;
}>`
  ${Logo} {
    max-height: ${(props) => (props.$smaller ? '28px' : '36px')};
  }
`;
